// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
    .CreateUser_sign__eTw-b{
        display: flex;
        place-content: center;
        margin-top: 25px;
    }

    .CreateUser_paper__1VHGy{
        width: 50%;
        height: 380px;
        padding: 2.5% 5% 0 5%;
        margin-top: 10px;
        font-size: 18px;
    }
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px){
    .CreateUser_sign__eTw-b{
    display: flex;
    place-content: center;
    margin-top: 25px;
    }

   .CreateUser_paper__1VHGy{
    width: 70%;
    height: 350px;
    padding: 3% 5%;
    margin-top: 10px;
    font-size: 18px;
   }
}

/*MOBILE*/
@media screen and (max-width:767px){
    .CreateUser_sign__eTw-b{
        display: flex;
        place-content: center;
        margin-top: 25px;
    }

   .CreateUser_paper__1VHGy{
    width: 80%;
    height: 350px;
    padding: 3% 5%;
    margin-top: 40px;
    font-size: 18px;
   }  
}`, "",{"version":3,"sources":["webpack://./src/pages/user_create/CreateUser.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI;QACI,aAAa;QACb,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,qBAAqB;QACrB,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA,SAAS;AACT;IACI;IACA,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB;;GAED;IACC,UAAU;IACV,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,eAAe;GAChB;AACH;;AAEA,SAAS;AACT;IACI;QACI,aAAa;QACb,qBAAqB;QACrB,gBAAgB;IACpB;;GAED;IACC,UAAU;IACV,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,eAAe;GAChB;AACH","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n    .sign{\n        display: flex;\n        place-content: center;\n        margin-top: 25px;\n    }\n\n    .paper{\n        width: 50%;\n        height: 380px;\n        padding: 2.5% 5% 0 5%;\n        margin-top: 10px;\n        font-size: 18px;\n    }\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px){\n    .sign{\n    display: flex;\n    place-content: center;\n    margin-top: 25px;\n    }\n\n   .paper{\n    width: 70%;\n    height: 350px;\n    padding: 3% 5%;\n    margin-top: 10px;\n    font-size: 18px;\n   }\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px){\n    .sign{\n        display: flex;\n        place-content: center;\n        margin-top: 25px;\n    }\n\n   .paper{\n    width: 80%;\n    height: 350px;\n    padding: 3% 5%;\n    margin-top: 40px;\n    font-size: 18px;\n   }  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sign": `CreateUser_sign__eTw-b`,
	"paper": `CreateUser_paper__1VHGy`
};
export default ___CSS_LOADER_EXPORT___;
